import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ResetPasswordRequestService {
  private API_URL = environment.API_URL;

  constructor(private http: HttpClient) {}

  requestResetLink(email: string) {
    return this.http.post(`${this.API_URL}/auth/forgot-password`, { email }, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
  }

  resetPassword(code: string, password: string, passwordConfirmation: string) {
    return this.http.post(`${this.API_URL}/auth/reset-password`, {
      code,
      password,
      passwordConfirmation
    }, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
  }
}
